let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e9tHh")).then(() => parcelRequire('b1h3K'));